import React from 'react';
import Abbr from './Abbr';

import { useFieldsObject } from '../hooks/useFields';

export const FieldDesc = ({ field, ...props }) => {
  const fields = useFieldsObject();

  const description = field.toUpperCase && fields[field];

  const abbrDescription = typeof description === 'string'
    ? description
    : <Abbr {...description} />;

  let output = '';
  if (description) {
    output = <strong>{abbrDescription}</strong>;
  } else {
    output = <span>{field}</span>;
  }

  return (
    <span {...props}>
      {output}
    </span>
  );
};

export default FieldDesc;
